import mixitup from 'mixitup';

export class Filters {

    constructor ( target = '.js-filter', options = {} ) {
        this.target = target;

        this.filters = {}

        this.options = {
            key: 'addressID',
            formTarget: '.js-filter__form',
            pagingTarget: '.js-filter__paging',
            moreTarget: '.js-filter__more',
            allTarget: '.js-filter__all',
            controlsTarget: '.js-filter__controls',
            itemTarget: '.js-filter__item',
            emptyTarget: '.js-filter__empty',
            ...options
        }
    }

    init () {
        this.container = document.querySelector( this.target );
        this.form = document.querySelector( this.options.formTarget );
        this.paging = Array.from( document.querySelectorAll( this.options.pagingTarget ) );
        this.more = document.querySelector( this.options.moreTarget );
        this.all = document.querySelector( this.options.allTarget );
        this.controls = document.querySelector( this.options.controlsTarget );
        this.empty = document.querySelector( this.options.emptyTarget );

        if ( this.all ) {
            this.all.addEventListener( 'click', () => {
                this.load();
            } )
        }
        if ( this.more ) {
            this.more.addEventListener( 'click', () => {
                this.loadMore();
            } )
        }

        if ( this.form ) {

            this.form.addEventListener( 'change', () => {
                this.createFilters()
            } )

            this.initialData().then( data => {

                this.houses = data.houses;

                this.mixer = mixitup( this.target, {
                    animation: {
                        enable: true
                    },
                    data: {
                        uidKey: this.options.key
                    },
                    render: {
                        target: this.render
                    },
                    load: {
                        dataset: this.houses
                    },
                    selectors: {
                        target: this.options.itemTarget
                    }
                } );
            } );
        }
    }

    load () {
        fetch( this.form.dataset.load, {
            method: 'GET'
        } ).then( res => {
            if ( !res.ok ) {
                throw Error( res );
                return res
            }
            return res.json();
        } ).then( res => {
            if ( res.total ) {
                this.total = res.total;
            } else {
                this.total = res.houses.length;
            }
            this.houses = res.houses;
            this.loaded = true;
            if ( this.controls ) {
                this.controls.classList.add( 'js-hide' );
            }
            this.setData();
        } ).catch( err => {
            console.log( err )
        } );
    }

    loadMore () {
        fetch( `${this.form.dataset.load}&count=${this.houses.length + 3}`, {
            method: 'GET'
        } ).then( res => {
            if ( !res.ok ) {
                throw Error( res );
                return res
            }
            return res.json();
        } ).then( res => {
            this.houses = res.houses;
            if ( !this.total ) {
                this.total = res.total;
            }
            if ( this.houses.length === this.total || this.total == undefined ) {
                this.loaded = true;
                if ( this.controls ) {
                    this.controls.classList.add( 'js-hide' );
                }
            }
            this.setData( true );
        } ).catch( err => {
            console.log( err )
        } );
    }

    createFilters () {
        Array.from( this.form.elements ).forEach( ( filter ) => {
            let name = filter.name.split( '[' );

            if ( !this.filters[ name[ 0 ] ] ) {
                this.filters[ name[ 0 ] ] = []
            }
            if ( filter.checked ) {
                this.filters[ name[ 0 ] ][ name[ 1 ].replace( ']', '' ) ] = filter.checked
            } else {
                delete this.filters[ name[ 0 ] ][ name[ 1 ].replace( ']', '' ) ]
            }
        } );


        Object.keys( this.filters ).filter( filter => {
            if ( Object.keys( this.filters[ filter ] ).length === 0 ) {
                delete this.filters[ filter ];
            }
        } )

        if ( !this.loaded ) {
            this.load();
        } else {
            this.setData();
        }
    }


    setData () {

        let houses = this.houses.filter( house => {

            let match = true;
            for ( const filter in this.filters ) {

                if ( filter in house ) {
                    //Checks if the current filter is process and splits into array
                    const categories = house[ filter ].toLowerCase().split( ', ' );
                    let contains = true;
                    if ( categories.length > 0 ) {
                        const filters = Object.keys( this.filters[ filter ] );
                        filters.forEach( filterMatch => {
                            contains = contains && ( categories.includes( filterMatch ) );
                        } );
                        match = ( match && contains );
                    }
                }
            }

            return match
        } )

        this.updatePaging( houses.length );
        this.mixer.dataset( houses ).then( () => {
        } )
    }

    updatePaging ( showing ) {
        this.paging.forEach( paging => {
            if ( paging.dataset.hide == 'true' && showing === 0 ) {
                paging.classList.add( 'js-hide' );
            } else {
                paging.classList.remove( 'js-hide' )
            }
            if ( showing === this.total ) {
                paging.innerText = `Showing all Properties`;
            } else {
                if(this.total == undefined ) {
                    paging.innerText = `Showing all Properties`;
                    paging.classList.add( 'js-hide' );
                } else {
                    paging.innerText = `Showing ${showing} of ${this.total} Properties`;
                }
            }
        } )

        if ( showing === 0 ) {
            setTimeout( () => {
                this.empty.classList.remove( 'js-hide' )
                setTimeout( () => {
                    this.empty.classList.remove( 'js-hide--animate' )
                }, 100 )
            }, 600 )
        } else {
            setTimeout( () => {
                this.empty.classList.add( 'js-hide' )
                this.empty.classList.add( 'js-hide--animate' )
            }, 800 )
        }
    }


    initialData () {
        return fetch( `${this.form.dataset.load}&count=6`, {
            method: 'GET'
        } ).then( res => {
            return res.json();
        } )

    }

    render ( house ) {
        return `<div class="c-card js-filter__item">
                    <figure class="c-card__image">
                        <a href="${house.url}">
                            <span class="u-sr">${house.addressTitle}</span>
                            <img src="${house.image.thumb}" alt="${house.image.alt}" class="c-card__image-src">
                        </a>
                    </figure>
                    <div class="c-card__content">
                        <h2 class="c-card__title">
                            <a href="${house.addressSlug}">
                                ${house.addressTitle}
                            </a>
                        </h2>
                        <h3 class="c-card__subtitle">
                            ${house.addressTown}
                        </h3>
                        <div class="c-card__copy">
                            <p>${house.excerpt}</p>
                        </div>
                        <div class="c-card__actions">
                            <a href="${house.url}" class="c-button">
                                Find out more
                            </a>
                        </div>
                    </div>
                </div>`
    }
}
